module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/register_success_new_qiaoji.png";